import React, { useContext } from 'react';
import { Row, HighlightGroup, Form, Subtext } from '@contently/toolkit';
import CheckboxSection from '../forms/checkboxes/checkbox_section';
import { FormikHandlersContext } from '../forms/dynamic_forms/DynamicFormikForm';

// TODO: consolidate logic w PropertiesCheckboxes component
function EnabledTagGroupsCheckboxes(props) {
  const { value, renderSubtext, id, tagGroups, label } = props;

  const { setFieldValue } = useContext(FormikHandlersContext);

  const handleChange = data => {
    // data is from one of multiple checkbox groups
    //   so make sure to add any checked checkboxes, remove any unchecked
    //   without mutating other value data
    let vals = [...value];
    const toAdd = data.filter(opt => opt.checked);
    const toRemove = data.filter(opt => !opt.checked);

    // Add checked
    toAdd.forEach(opt => {
      if (vals.indexOf(opt.value) === -1) {
        vals.push(opt.value);
      }
    });

    // Remove unchecked
    vals = vals.filter(v => !toRemove.map(opt => opt.value).includes(v));

    setFieldValue(id, vals);
  };

  const compare = (a, b) => {
    const labelA = a.label.toUpperCase();
    const labelB = b.label.toUpperCase();

    let comparison = 0;
    if (labelA > labelB) {
      comparison = 1;
    } else if (labelA < labelB) {
      comparison = -1;
    }
    return comparison;
  };

  const renderSections = () => {
    return (
      <Row>
        <CheckboxSection
          onChange={handleChange}
          options={tagGroups
            .map(opt => {
              return { ...opt, checked: value.includes(opt.value) };
            })
            .sort(compare)}
          id="contentCollectionAttributes.enabledTagGroupIds"
        />
      </Row>
    );
  };

  const subtext = () => {
    if (renderSubtext && typeof renderSubtext === 'function') {
      return renderSubtext();
    }

    if (renderSubtext && typeof renderSubtext === 'string') {
      return <Subtext>{renderSubtext}</Subtext>;
    }

    return null;
  };

  return (
    <Row>
      <Form.Label>{label}</Form.Label>
      {subtext()}
      <HighlightGroup>{renderSections()}</HighlightGroup>
    </Row>
  );
}

export default EnabledTagGroupsCheckboxes;



// WEBPACK FOOTER //
// ./app/javascript/app/components/integrations/EnabledTagGroupsCheckboxes.jsx